import { useBlackfeo } from "@/hooks/use-blackfeo";
import { BlackfeoTopBar } from "@/components/blackfeo/BlackfeoPontos";
import { BLACK_CTA_VENDA, BLACK_ULTIMOS_DIAS } from "@/lib/black2x1/escassez";
import { useEffect } from "react";
import { instalarOrigemBlack, blackListaHref } from "@/lib/black2x1/origem-visita";
/** Barra fina da BLACK 2x1 2026 no topo do site. Some após o fim das inscrições. */
import { ArrowRight } from "lucide-react";
import { useBlackSale } from "@/hooks/use-black-sale";

const BLACK_FIM = Date.parse("2026-11-04T02:59:59Z");

export function BlackTopBar(props: { origem: string; tall?: boolean }) {
  const blackfeo = useBlackfeo();
  return blackfeo ? <BlackfeoTopBar ponto={`barra-${props.origem}`} /> : <BlackDobroTopBar {...props} />;
}

function BlackDobroTopBar({ origem, tall = false }: { origem: string; tall?: boolean }) {
  const sale = useBlackSale();
  useEffect(() => instalarOrigemBlack(), []);
  if (Date.now() > BLACK_FIM) return null;
  const saleStyle = sale;
  return (
    <a
      href={blackListaHref(`barra-${origem}`)}
      className={`group flex w-full items-center justify-center gap-2 px-4 ${tall || true ? "py-[0.82rem]" : ""} text-center text-xs font-normal sm:text-sm ${saleStyle ? "border-b-2 border-black bg-black-urgency-yellow text-black" : "border-b border-white/5 bg-[#07060f] text-white"}`}
      style={{ backgroundImage: saleStyle
        ? "linear-gradient(90deg, rgba(0,0,0,0.16), transparent 30%, transparent 70%, rgba(0,0,0,0.16))"
        : "linear-gradient(90deg, rgba(124,58,237,0.35), transparent 40%, transparent 60%, rgba(124,58,237,0.35))" }}
    >
      {sale ? (
        <>
          <span className="whitespace-nowrap font-black uppercase">🔥 {BLACK_ULTIMOS_DIAS}</span>
          <span className="whitespace-nowrap font-bold text-black/70"><span className="hidden sm:inline">BLACK 2x1 · </span>vendas abertas</span>
        </>
      ) : (
        <>
          <span className="font-bold text-[#c39cf5]">BLACK 2x1</span>
          <span className="hidden sm:inline">· 2 pós-graduações, pague apenas 1</span>
        </>
      )}
      <span className={`inline-flex items-center gap-1 whitespace-nowrap font-bold underline-offset-4 group-hover:underline ${sale ? "text-black" : "text-[#2fe0d6]"}`}>
         {sale ? BLACK_CTA_VENDA : "Entre na lista"} <ArrowRight className="h-3 w-3" />
      </span>
    </a>
  );
}
